import React from 'react';
import { Navigate, useNavigate, useParams } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { Frame } from '../../components/shell/AppShell';
import PageHeader from '../../components/shell/PageHeader';
import OperatorManagement from '../../components/admin/OperatorManagement';
import AssignmentManagement from '../../components/admin/AssignmentManagement';
import BroadcastPanel from '../../components/admin/BroadcastPanel';
import AuditLog from '../../components/admin/AuditLog';
import LastResort from '../../components/admin/LastResort';
import { canReach } from '../../lib/navigation';
import adminArt from '../../assets/bg/founder-admin.webp';

// The existing administration panels, each now a child page of More. Their
// own logic, confirmations and re-authentication are untouched.
const SECTIONS = {
  operators: { title: 'Operators', Component: OperatorManagement },
  assignments: { title: 'Assignments', Component: AssignmentManagement },
  broadcast: { title: 'Broadcast', Component: BroadcastPanel },
  audit: { title: 'Audit Log', Component: AuditLog },
  'last-resort': { title: 'Last Resort', Component: LastResort },
};

const StaffSection = () => {
  const { section } = useParams();
  const { user } = useAuth();
  const navigate = useNavigate();
  const entry = SECTIONS[section];

  // A typed URL gets the same answer the menu gives: an operator asking for
  // /admin/more/operators is simply returned to More. The API refuses too.
  if (!entry || !canReach(user, `/admin/more/${section}`)) {
    return <Navigate to="/admin/more" replace />;
  }
  const { title, Component } = entry;

  return (
    <Frame user={user} background={adminArt} scrim={0.6} activeKey="more">
      <div data-testid={`staff-section-${section}`}>
        <PageHeader title={title} onBack={() => navigate('/admin/more')} />
        <div className="mx-auto max-w-5xl px-4 pb-6 pt-3">
          <div className="rounded-xl border border-border bg-card/90 p-3 md:p-5 backdrop-blur-sm">
            <Component />
          </div>
        </div>
      </div>
    </Frame>
  );
};

export default StaffSection;
